<template>
  <div>
    <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
    <b-card class="mb-2 mx-2 shadow bg-light">
      <b-card-title title-tag="h6"
        >Réception de paiements débiteurs</b-card-title
      >
      <b-row>
        <mh-input
          @update="getwarrant"
          debounce="400"
          mhClass="col-2"
          field="number"
          :table="warrantNumber"
          :state="warrant !== false"
          info="Précédé d'un ':' pour chercher par n° de compte"
        ></mh-input>
        <b-col lg="10" v-if="warrant">
          <b-row>
            <mh-input
              mhClass="col-2"
              label="Débiteur"
              field="nom_complet"
              readonly
              :table="warrant.debiteur"
            >
            </mh-input>
            <mh-input
              mhClass="col-2"
              label="Créancier"
              field="nom_soc"
              readonly
              :table="warrant.creancier"
            >
            </mh-input>
            <mh-input
              mhClass="col-2"
              label="Solde"
              field="solde"
              readonly
              :table="warrant"
              append="€"
            >
            </mh-input>
            <mh-input
              mhClass="col-2"
              label="Agenda"
              field="popUpAgenda"
              :table="warrant"
              @change="modify_agenda()"
            ></mh-input>
            <b-button
              v-if="warrant.arrangementID.value != 0"
              variant="success"
              style="align-self: center"
              class="ml-3 col-2"
              size="sm"
              :to="{
                name: 'settlement',
                params: { id: warrant.arrangementID.value },
              }"
              >Arrangement ({{ warrant.arrangementID.value }})</b-button
            >
            <b-button
              v-else
              :to="{
                name: 'newSettlement',
                params: { id: warrant.ID.value },
              }"
              class="mr-3 col-2"
              size="sm"
              style="align-self: center"
              variant="secondary"
              ><b-icon-patch-check class="mr-2"></b-icon-patch-check>Marquer un
              arrangement</b-button
            >
            <b-button
              :to="{
                name: 'warrantView',
                params: { id: warrant.ID.value },
              }"
              size="sm"
              class="ml-3 col-1"
              style="align-self: center"
              variant="secondary"
              >Mandat
              <b-icon-arrow-right-circle
                class="ml-2"
              ></b-icon-arrow-right-circle
            ></b-button>
          </b-row>
        </b-col>
      </b-row>
      <div v-if="propositions && propositions.length > 0" class="row">
        <b-card class="mt-3 shadow bg-light">
          <b-table
            fixed
            id="warrantsTable"
            striped
            small
            hover
            :fields="mandatsFields"
            :items="propositions"
          >
            <template v-slot:cell(mandatID)="data">
              <a @click.prevent="setWarrantID(data.item.mandatID)" href=""
                >{{ data.item.mandatID }} : {{ data.item.debiteur }}</a
              >
            </template>
          </b-table>
        </b-card>
      </div>
      <b-row v-if="payment" class="mt-3">
        <b-col lg="12">
          <h5 v-if="!modify">Nouveau paiement</h5>
          <h5 v-else>Modifier le paiement</h5>
        </b-col>
        <mh-input
          mhClass="col-1"
          labelColsLg="0"
          label="Date"
          field="date"
          :table="payment"
          @keyup.enter.native="focus('montant')"
        ></mh-input>
        <mh-input
          mhClass="col-1"
          labelColsLg="0"
          append="€"
          field="montant"
          :table="payment"
          @keyup.enter.native="focus('type')"
        ></mh-input>
        <mh-input
          mhClass="col-1"
          label="Type"
          labelColsLg="0"
          field="type"
          :table="payment"
          @keyup.enter.native="focus('compte_debiteur')"
        ></mh-input>
        <mh-input
          mhClass="col-2"
          labelColsLg="0"
          label="Compte société"
          field="compte_societeID"
          :table="payment"
          @change="changeCompte()"
          @keyup.enter.native="focus('compte_debiteur')"
        ></mh-input>
        <mh-input
          mhClass="col-2"
          labelColsLg="0"
          label="Compte débiteur"
          field="compte_debiteur"
          :table="payment"
          @keyup.enter.native="focus('numero_extrait')"
        ></mh-input>
        <mh-input
          mhClass="col-2"
          labelColsLg="0"
          label="Extrait"
          field="numero_extrait"
          :table="payment"
          @keyup.enter.native="focus('negotiateurID')"
        ></mh-input>
        <mh-input
          mhClass="col-1"
          labelColsLg="0"
          label="Réception"
          field="reception"
          readonly
          :table="payment"
        ></mh-input>
        <mh-input
          mhClass="col-1"
          labelColsLg="0"
          label="Négociateur"
          field="negotiateurID"
          :table="payment"
          @keyup.enter.native="savePayment"
        ></mh-input>
        <b-col lg="1" style="align-self: end">
          <b-button @click="savePayment" size="sm" variant="success"
            >Confirmer</b-button
          >
          <b-button
            v-if="modify"
            @click="cancelModify"
            size="sm"
            variant="danger"
            class="ml-2"
            >Annuler</b-button
          >
        </b-col>
      </b-row>
      <hr v-if="warrant" />

      <b-row v-if="warrant" class="mt-3">
        <b-col lg="12">
          <b-table
            small
            hover
            :fields="paymentsFields"
            :items="warrant.paiements"
            v-if="warrant.paiements.length > 0"
          >
            <template v-slot:cell(date)="data">{{
              toDate(data.item.date)
            }}</template>
            <template v-slot:cell(montant)="data"
              >{{ twoDigits(data.item.montant) }} €</template
            ><template v-slot:cell(actions)="data">
              <div class="d-flex justify-content-center">
                <b-button
                  class="ml-3 btn-xs"
                  size="sm"
                  variant="success"
                  @click="editPayment(data.item.ID)"
                  ><b-icon-pencil-fill></b-icon-pencil-fill
                ></b-button>
                <b-button
                  class="ml-3 btn-xs"
                  size="sm"
                  variant="danger"
                  @click="deletePayment(data.item.ID)"
                  ><b-icon-x-circle></b-icon-x-circle
                ></b-button>
              </div>
            </template>
            <template v-slot:bottom-row>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td>
                <strong>
                  Total :
                  <span class="float-right"
                    >{{ twoDigits(paymentsTotalVTAC) }} €</span
                  >
                </strong>
              </td>
              <td />
            </template>
          </b-table>
          <div v-else>
            <i>Pas encore de paiements pour cette facture</i>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import warrants from "@/services/warrants.js";
import payments from "@/services/payments.js";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "addWarrantsPayments",
  props: {},
  components: {
    MhInput,
  },

  created() {
    this.getwarrant();
  },
  computed: {
    paymentsTotalVTAC() {
      return this.twoDigits(
        this.warrant.paiements.reduce((a, b) => a + Number(b.montant), 0)
      );
    },
  },
  methods: {
    modify_agenda() {
      if (
        this.warrant.popUpAgenda.value &&
        !this.toDate(this.warrant.popUpAgenda.value)
      ) {
        this.warrant.popUpAgenda.value = null;
        this.saveWarrant();
        return;
      }
      if (this.warrant.status.value == "open") {
        this.warrant.status.value = "stopped";
      }
      this.saveWarrant();
    },
    saveWarrant() {
      warrants
        .update(this.warrant.ID.value, this.warrant, false, false, false)
        .then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("Mandat mis à jour", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
          }
        });
    },
    setWarrantID(id) {
      this.warrantNumber.number.value = "" + id;
      this.getwarrant();
    },
    changeCompte() {
      if (this.payment.compte_societeID.value == 7) {
        this.payment.reception.value = "creancier";
      } else {
        this.payment.reception.value = "societe";
      }
    },
    focus(id) {
      document.getElementById(id).focus();
      document.getElementById(id).select();
    },

    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },

    getwarrant(data = {}) {
      if (this.warrantNumber.number.value.trim() == "") return;
      warrants.get(this.warrantNumber.number.value).then((response) => {
        if (response.data) {
          if (response.data.mandats) {
            this.propositions = response.data.mandats;
            this.warrant = false;
            this.payment = false;
          } else {
            this.propositions = false;
            this.warrant = response.data;
            this.warrant.solde = {
              type: "decimal",
              value: this.warrant.solde,
              label: "Solde",
            };
            payments
              .payment({
                warrant_id: this.warrant.ID.value,
                payment_id: "new",
              })
              .then((response) => {
                this.payment = response.data;
                this.payment.date.type = "varchar";
                this.payment.date.pattern = "[0-9]{4}-[0-9]{2}-[0-9]{2}";
                this.changeCompte();
              });
            if (data.focus) {
              document.getElementById("number").focus();
              document.getElementById("number").select();
            }
          }
        } else {
          this.warrant = false;
          this.payment = false;
          this.propositions = false;
        }
      });
    },
    editPayment(id) {
      payments
        .payment({
          warrant_id: this.warrant.ID.value,
          payment_id: id,
        })
        .then((response) => {
          this.payment = response.data;
          this.payment.date.type = "varchar";
          this.payment.date.pattern = "[0-9]{4}-[0-9]{2}-[0-9]{2}";
          this.modify = true;
          this.$nextTick(() => {
            document.getElementById("montant").focus();
            document.getElementById("montant").select();
          });
        });
    },
    deletePayment(id) {
      payments
        .delete_payment({
          warrant_id: this.warrant.ID.value,
          payment_id: id,
        })
        .then(() => {
          this.getwarrant({ focus: true });
          this.$bvToast.toast("Paiement supprimé", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
        });
    },
    cancelModify() {
      this.modify = false;
      this.getwarrant();
    },
    savePayment() {
      if (this.modify) {
        payments
          .update_payment({
            warrant_id: this.warrant.ID.value,
            payment_id: this.payment.ID.value,
            payment: this.payment,
          })
          .then((response) => {
            if (response.data.success) {
              this.$bvToast.toast("Paiement modifié", {
                title: `Recuperator`,
                toaster: "b-toaster-top-right",
                variant: "success",
                autoHideDelay: 2000,
                solid: false,
              });
              for (let el in this.warrant) {
                if (this.payment[el]) {
                  this.payment[el].error = false;
                }
              }
              this.modify = false;
              this.getwarrant({ focus: true });
            } else if (response.data.fail) {
              for (let el in this.warrant) {
                if (this.payment[el]) {
                  this.payment[el].error = false;
                }
              }
              response.data.fail.forEach((element) => {
                this.payment[element.field].error = element.errors.join(" ; ");
              });
            }
          });
      } else {
        payments
          .update_payment({
            warrant_id: this.warrant.ID.value,
            payment_id: "new",
            payment: this.payment,
          })
          .then((response) => {
            if (response.data.success) {
              this.$bvToast.toast("Paiement encodé", {
                title: `Recuperator`,
                toaster: "b-toaster-top-right",
                variant: "success",
                autoHideDelay: 2000,
                solid: false,
              });
              for (let el in this.warrant) {
                if (this.payment[el]) {
                  this.payment[el].error = false;
                }
              }
              this.getwarrant({ focus: true });
            } else if (response.data.fail) {
              for (let el in this.warrant) {
                if (this.payment[el]) {
                  this.payment[el].error = false;
                }
              }
              response.data.fail.forEach((element) => {
                this.payment[element.field].error = element.errors.join(" ; ");
              });
            }
          });
      }
    },
  },
  data() {
    return {
      warrantNumber: {
        number: {
          label: "Numéro de mandat ou débiteur",
          type: "INT",
          value: "",
        },
      },
      modify: false,
      warrant: false,
      payment: false,
      propositions: false,
      mandatsFields: [
        {
          key: "mandatID",
          label: "Numéro de mandat",
          sortable: true,
        },
      ],
      paymentsFields: [
        {
          key: "date",
          label: "Date",
          sortable: true,
        },
        {
          key: "iban",
          label: "Compte société",
          sortable: true,
        },
        {
          key: "compte_debiteur",
          label: "Compte débiteur",
          sortable: true,
        },
        {
          key: "reception",
          label: "Réception",
          sortable: true,
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
        },
        {
          key: "numero_extrait",
          label: "Extrait",
          sortable: false,
        },
        {
          key: "initiale",
          label: "Négociateur",
          thStyle: "width:120px",
          class: "text-center",
          sortable: true,
        },
        {
          key: "montant",
          label: "Montant",
          sortable: true,
          class: "text-right",
        },
        {
          key: "actions",
          label: "",
          sortable: true,
          class: "text-right",
        },
      ],
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats",
          to: { name: "warrants" },
        },
        {
          text: "Réception de paiements",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>